import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Button, Col, List, message, Modal, Row, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import { loadDiscounts } from "../../../application/discounts-slice";
import { ServiceLocater, Services } from "../../../service-locater";
import { DiscountRepository } from "../../../domain";
import I18n from "../../i18n";
import moment from "moment-jalaali";

const { Text } = Typography;

export default function Discounts() {
  const dispatch = useAppDispatch();
  const { loading, discounts } = useAppSelector((state) => state.discounts);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    if (loading !== "succeeded") stableDispatch(loadDiscounts());
  }, [stableDispatch, loading]);

  const [deleteModalVisible, setDeleteModalVisible] = useState<{
    selectedId?: string;
    visible: boolean;
  }>({ visible: false });
  const openDeleteDialog = (id: string) =>
    setDeleteModalVisible({ selectedId: id, visible: true });
  const closeDeleteModal = () =>
    setDeleteModalVisible({ selectedId: undefined, visible: false });

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const deleteDiscount = async () => {
    if (deleteModalVisible.selectedId === undefined) return;
    setIsDeleteLoading(true);
    const res = await ServiceLocater.get<DiscountRepository>(
      Services.DiscountRepository
    ).remove(deleteModalVisible.selectedId);
    setIsDeleteLoading(false);
    res.fold(
      (_) => {
        message.error(I18n.general.networkError);
      },
      (_) => {
        closeDeleteModal();
        dispatch(loadDiscounts());
        message.success(I18n.discount.deleteSuccess);
      }
    );
  };

  const isLoading = loading !== "succeeded";
  return (
    <div>
      <List
        style={{ paddingBottom: 8 }}
        dataSource={discounts}
        loading={isLoading}
        renderItem={(item, index) => {
          return (
            <List.Item
              style={{
                padding: "8px 16px",
                borderBottom: "1px solid #0000001a",
              }}
              actions={[
                <Button
                  type="link"
                  disabled={isDeleteLoading}
                  onClick={() => openDeleteDialog(item.id)}
                  danger
                >
                  <DeleteOutlined />
                </Button>,
              ]}
            >
              <Row justify="space-between" align="middle">
                <Col>
                  <div>
                    <Text>{`${I18n.discount.code}: ${item.code}`}</Text>
                    <br />
                    <Text>{`${I18n.discount.expiration}: ${moment
                      .utc(item.expiration)
                      .format("jYYYY-jM-jD")
                      .replace(/-/g, "/")}`}</Text>
                    <br />
                    <Text>{`${I18n.discount.amount.replace(
                      " (به تومان)",
                      ""
                    )}: ${item.amount.toLocaleString()} تومان`}</Text>
                    <br />
                    <Text>{`${I18n.discount.discountType}: ${
                      item.type === "product"
                        ? I18n.discount.product
                        : I18n.discount.delivery
                    }`}</Text>
                    <br />
                    {item.user !== undefined ? (
                      <Text>
                        کاربر:‌{" "}
                        {`${item.user.firstName} ${item.user.sureName} - ${item.user.phoneNumber}`}
                      </Text>
                    ) : (
                      <Fragment />
                    )}
                  </div>
                </Col>
              </Row>
            </List.Item>
          );
        }}
      />

      <Modal
        title={I18n.discount.deleteConfirm}
        visible={deleteModalVisible.visible}
        closable={!isDeleteLoading}
        maskClosable={!isDeleteLoading}
        onCancel={isDeleteLoading ? undefined : closeDeleteModal}
        onOk={deleteDiscount}
        confirmLoading={isDeleteLoading}
      />
    </div>
  );
}
